import templateDefaults from '../templateDefaults';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

export default {
  previewImage: '/img/event/fullscreen-2.png',
  title: 'Fullscreen 2',
  templateData() {
    return {
      version: 'v1.1',
      title: 'Event Fullscreen 2',
      ...templateDefaults,
      elements: [
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Amphitheatre',
          locked: false,
          text: '<p class="ql-align-center"><strong>AMPHITHEATRE</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeInDown',
          animationInDuration: 300,
          animationInDelay: 1400,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOutDown',
          animationOutDuration: 300,
          animationOutDelay: 0,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 690,
            left: 1319,
            width: 600,
            height: 30,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Montserrat',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 18,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 10,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'July 15-17',
          locked: false,
          text: '<p class="ql-align-center"><strong>July 15-17</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeInDown',
          animationInDuration: 300,
          animationInDelay: 1400,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOutDown',
          animationOutDuration: 300,
          animationOutDelay: 0,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 660,
            left: 1319,
            width: 600,
            height: 30,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Montserrat',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 18,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 10,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: '20 - white',
          locked: false,
          text: '<p class="ql-align-center"><strong>20</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInUp',
          animationInDuration: 300,
          animationInDelay: 1100,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutDown',
          animationOutDuration: 300,
          animationOutDelay: 300,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 410,
            left: 0,
            width: 1920,
            height: 562,
            opacity: '1.00',
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Montserrat',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 562,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: '20 - cyan',
          locked: false,
          text: '<p class="ql-align-center"><strong>20</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInUp',
          animationInDuration: 300,
          animationInDelay: 1100,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutDown',
          animationOutDuration: 300,
          animationOutDelay: 300,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 422,
            left: 0,
            width: 1920,
            height: 562,
            opacity: '0.60',
            color: 'rgb(0, 196, 221)',
            fontFamily: 'Montserrat',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 562,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: '20 - marigold',
          locked: false,
          text: '<p class="ql-align-center"><strong>20</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInUp',
          animationInDuration: 300,
          animationInDelay: 1000,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutDown',
          animationOutDuration: 300,
          animationOutDelay: 400,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 300,
          loopingAnimationDelay: 400,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 140,
            left: 0,
            width: 1920,
            height: 562,
            opacity: 1,
            color: 'rgb(255, 208, 19)',
            fontFamily: 'Montserrat',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 562,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: '20 - magenta',
          locked: false,
          text: '<p class="ql-align-center"><strong>20</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInUp',
          animationInDuration: 300,
          animationInDelay: 1000,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutDown',
          animationOutDuration: 300,
          animationOutDelay: 400,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 152,
            left: 0,
            width: 1920,
            height: 562,
            opacity: 1,
            color: 'rgb(222, 55, 79)',
            fontFamily: 'Montserrat',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 562,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Event festival',
          locked: false,
          text: '<p class="ql-align-center"><strong>Event festival</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInDown',
          animationInDuration: 300,
          animationInDelay: 900,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutUp',
          animationOutDuration: 300,
          animationOutDelay: 500,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 100,
            left: 0,
            width: 1920,
            height: 120,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Montserrat',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 100,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 36,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Anything is possible',
          locked: false,
          text: '<p class="ql-align-center"><strong>Anything is possible</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'slideInDown',
          animationInDuration: 300,
          animationInDelay: 900,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'slideOutUp',
          animationOutDuration: 300,
          animationOutDelay: 500,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 60,
            left: 0,
            width: 1920,
            height: 40,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Montserrat',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 18,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 10,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Is Possible',
          locked: false,
          text: '<p class="ql-align-center"><strong>﻿Is POSSIBLE</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 600,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 800,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 560,
            left: -40,
            width: 2000,
            height: 390,
            opacity: '0.20',
            color: 'rgb(255, 208, 19)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 390,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Anything',
          locked: false,
          text: '<p class="ql-align-center"><strong>Anything</strong></p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 300,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 1100,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          fitText: false,
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 170,
            left: 0,
            width: 1920,
            height: 390,
            opacity: '0.20',
            color: 'rgb(255, 208, 19)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 390,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'image',
          name: 'Background',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/backgrounds/event-concert.jpg`,
          cssClasses: '',
          animation: true,
          animationInStyle: 'fadeIn',
          animationInDuration: 300,
          animationInDelay: 0,
          animationInEasing: '0.420, 0.000, 1.000, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 300,
          animationOutDelay: 1400,
          animationOutEasing: '0.000, 0.000, 0.580, 1.00',
          loopingAnimation: false,
          loopingAnimationStyle: 'flipInOut',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 0,
            left: 0,
            width: 1920,
            height: 1080,
            opacity: 1,
          },
        },
      ],
    };
  },
};
